import { TMonthlyTarget, TUpsertMonthlyTargetReqDto } from "@/api/services/main/dashboard/dtos/monthly-target.dto";
import { TMonthlyTargetForm } from "@/features/dashboard/types/MonthlyTargetForm";

export const convertMonthlyTargetFormDataReq = (data: TMonthlyTargetForm, targetMonth: string): TUpsertMonthlyTargetReqDto => {
  const raw = {
    targetMonth,
    targetJobs: data.targetJobs ?? null,
    targetCases: data.targetCases ?? null,
    targetOpenJobs: data.targetOpenJobs ?? null,
    targetTalents: data.targetTalents ?? null,
    targetMatchingBeforeProposals: data.targetMatchingBeforeProposals ?? null,
    targetMatchingBeforeProposalRate: data.targetMatchingBeforeProposalRate ?? null,
    targetMatchingRecommendations: data.targetMatchingRecommendations ?? null,
    targetMatchingRecommendationRate: data.targetMatchingRecommendationRate ?? null,
    targetMatchingInterviews: data.targetMatchingInterviews ?? null,
    targetMatchingInterviewRate: data.targetMatchingInterviewRate ?? null,
    targetMatchingOffers: data.targetMatchingOffers ?? null,
    targetMatchingOfferRate: data.targetMatchingOfferRate ?? null,
    targetMatchingAcceptances: data.targetMatchingAcceptances ?? null,
    targetMatchingAcceptanceRate: data.targetMatchingAcceptanceRate ?? null,
    memo: data.memo ?? null,
  };

  const payload = raw as TUpsertMonthlyTargetReqDto;
  return payload;
};

export const convertMonthlyTargetToFormDataRes = (data?: TMonthlyTarget): Partial<TMonthlyTargetForm> | undefined => {
  if (!data) return undefined;

  const response = {
    targetJobs: data.targetJobs ?? null,
    targetCases: data.targetCases ?? null,
    targetOpenJobs: data.targetOpenJobs ?? null,
    targetTalents: data.targetTalents ?? null,
    targetMatchingBeforeProposals: data.targetMatchingBeforeProposals ?? null,
    targetMatchingBeforeProposalRate: data.targetMatchingBeforeProposalRate ?? null,
    targetMatchingRecommendations: data.targetMatchingRecommendations ?? null,
    targetMatchingRecommendationRate: data.targetMatchingRecommendationRate ?? null,
    targetMatchingInterviews: data.targetMatchingInterviews ?? null,
    targetMatchingInterviewRate: data.targetMatchingInterviewRate ?? null,
    targetMatchingOffers: data.targetMatchingOffers ?? null,
    targetMatchingOfferRate: data.targetMatchingOfferRate ?? null,
    targetMatchingAcceptances: data.targetMatchingAcceptances ?? null,
    targetMatchingAcceptanceRate: data.targetMatchingAcceptanceRate ?? null,
    memo: data.memo ?? null,
  };

  return response;
};
